import httpClient from '@/plugins/httpClient'
import { toFormData } from '@/services/api/formData'

const MULTIPART = { headers: { 'Content-Type': 'multipart/form-data' } }

export async function query(api, params = {}) {
  const response = await httpClient.get('/getQueryBack', { params: { ...params, api, _ts: Date.now() } })
  return response?.data?.response
}

export function destroy(api, params = {}) {
  return httpClient.get('/deleteQueryBack', { params: { ...params, api, _ts: Date.now() } })
}

export function post(api, payload = {}, options = {}) {
  const form = toFormData({ ...payload, api }, options)
  return httpClient.post('/postQueryBack', form, MULTIPART).then(r => r.data)
}

export function put(api, payload = {}, options = {}) {
  const form = toFormData({ ...payload, api }, options)
  return httpClient.put('/putQueryBack', form, MULTIPART)
}

export function patch(api, payload = {}, options = {}) {
  const form = toFormData({ ...payload, api }, options)
  return httpClient.patch('/patchQueryBack', form, MULTIPART)
}
